const thisEnv = window.__conf__;

export default thisEnv;
